import clsx from "clsx";
import { motion } from "motion/react";
import { Icon } from "../icons";
import type { ClassNameProps } from "../types";

/** Props Interface */
interface CloseButtonProps extends ClassNameProps {
	onClose: () => void;
}

export function CloseButton({ onClose, className }: CloseButtonProps) {
	/** Render */
	return (
		<motion.div
			className={clsx(
				"top-0 right-0 absolute opacity-80 hover:opacity-100 p-2 text-color cursor-pointer",
				className,
			)}
			onClick={onClose}
			onKeyUp={onClose}
			whileTap={{
				scale: 0.9,
			}}
		>
			<Icon name="X" />
		</motion.div>
	);
}
